import styled from "styled-components";
import { Font, ColorDark, breakpoints } from "@/shared/Constants";
export const IcoPaywall = styled.div`
  > div {
    width: 16px;
    height: 16px;
    background: #fddf37;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    line-height: 15px;
  }
`;

export const PaywallIcoBox = styled.div`
  display: flex;
  align-items: center;
  &.nota {
    p {
      font-size: 15px;
      line-height: 25px;
    }
  }
  p {
    ${Font.sansRegular};
    color: #000;
    font-size: 10px;
    letter-spacing: 0.3px;
    margin-left: 7px;
    ${breakpoints.darkMode} {
      [data-theme="dark"] & {
        color: ${ColorDark.textLight};
      }
    }
  }
`;
